import { render } from "./Info copy.vue?vue&type=template&id=10136852"
import script from "./Info copy.vue?vue&type=script&lang=js"
export * from "./Info copy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__